import { Box, Flex, Text } from "@chakra-ui/react";
import { palette } from "./theme";

export const SectionLabel = ({
  children,
}: React.PropsWithChildren): JSX.Element => (
  <Flex
    align="center"
    gap={3}
    my={4}
    color={palette.label}
    fontWeight="700"
    fontSize="13px"
  >
    <Text whiteSpace="nowrap">{children}</Text>
    <Box h="1px" bg={palette.border} flex={1} />
  </Flex>
);

export const SectionIntro = ({
  children,
}: React.PropsWithChildren): JSX.Element => (
  <Text color={palette.muted} fontSize="13px" mt={-2} mb={3} lineHeight="1.5">
    {children}
  </Text>
);
